import _ from 'lodash'

const isListsLoading = (state) => _.get(state, 'loading')

const listsMeta = (state) => _.get(state, 'listsMeta')
const lists = (state) => _.get(state, 'lists')
const listsPageMeta = (state) => _.get(state, 'listsPageMeta')
const sortType = (state) => _.get(state, 'sortType')


export default {
	isListsLoading,
	lists,
	listsMeta,
	listsPageMeta,
	sortType,
}
